<template>
  <div class="login-wrap">
    <div class="login-card">
      <h1 class="login-title">🔐 口令验证</h1>
      <p class="login-desc">请输入授权口令进入后台</p>
      <NInput
        v-model:value="token"
        type="password"
        show-password-on="click"
        placeholder="输入口令..."
        size="large"
        class="login-input"
        @keyup.enter="doLogin"
      />
      <NButton type="primary" size="large" block :loading="loading" @click="doLogin" class="login-btn">
        验证
      </NButton>
      <p class="login-err" v-if="errMsg">{{ errMsg }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { NInput, NButton } from 'naive-ui'

const router = useRouter()
const route = useRoute()
const token = ref('')
const loading = ref(false)
const errMsg = ref('')

function saveToken(t: string) {
  localStorage.setItem('auth_token', t)
  const to = (route.query.redirect as string) || '/'
  router.replace(to)
}

onMounted(() => {
  const urlToken = route.query.token as string
  if (urlToken) {
    saveToken(urlToken)
    return
  }
  const saved = localStorage.getItem('auth_token')
  if (saved) {
    saveToken(saved)
  }
})

async function doLogin() {
  const t = token.value.trim()
  if (!t) {
    errMsg.value = '请输入口令'
    return
  }
  loading.value = true
  errMsg.value = ''
  // 用后端任意需要认证的接口验证 token
  try {
    const resp = await fetch(`${globalThis.location.origin}/api/Game/GetUserList?page=1&pageSize=1`, {
      headers: { 'X-Auth-Token': t, 'Content-Type': 'application/json' }
    })
    if (resp.status === 200) {
      saveToken(t)
    } else if (resp.status === 401) {
      errMsg.value = '口令错误，请重试'
    } else {
      saveToken(t) // 其他错误也先存着
    }
  } catch {
    saveToken(t) // 网络不通也先存着
  } finally {
    loading.value = false
  }
}
</script>

<style scoped lang="scss">
.login-wrap {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #1a1a2e;
  padding: 20px;
}

.login-card {
  width: 100%;
  max-width: 380px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 40px 32px;
  text-align: center;
  backdrop-filter: blur(10px);
}

.login-title {
  font-size: 22px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 8px;
}

.login-desc {
  font-size: 13px;
  color: #888;
  margin-bottom: 24px;
}

.login-input {
  margin-bottom: 16px;
}

.login-btn {
  margin-bottom: 12px;
}

.login-err {
  color: #f87171;
  font-size: 13px;
  margin-top: 4px;
}

</style>
